<template>
    <div>
        <b-modal
            id="add-text-field-popup"
            ref="modal"
            :title="title"
            size="sm"
            hide-footer
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
            modal-class="hide-footer"
            @hidden="hideModal()"
        >
            <b-form @submit.stop.prevent="onSubmit()" @reset="hideModal">
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Label"
                            label-for="label"
                        >
                            <b-form-input
                                id="label"
                                v-model="fieldData.label"
                                v-validate="'required|max:100|min:1'"
                                type="text"
                                placeholder="Enter field label"
                                autocomplete="no"
                                data-vv-name="label"
                                :class="{
                                    'is-invalid': errors.has('label'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-2"
                            label="Placeholder"
                            label-for="placeholder"
                        >
                            <b-form-input
                                id="placeholder"
                                v-model="fieldData.placeholder"
                                v-validate="'required|max:100|min:1'"
                                type="text"
                                placeholder="Enter placeholder text"
                                autocomplete="no"
                                data-vv-name="placeholder"
                                :class="{
                                    'is-invalid': errors.has('placeholder'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-4"
                            class="kyc-status-radio overwrite-radio"
                            label="Is Required?"
                            label-for="isrequired"
                        >
                            <b-form-radio-group
                                id="isrequired"
                                v-model="fieldData.isRequired"
                                :options="form.radioOptions"
                                name="isrequired"
                            ></b-form-radio-group>
                        </b-form-group>
                    </div>
                </div>

                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Submit"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                        :disabled="loading"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        /**
         * Value to determine the current compose mode which
         * varies between 'add' and 'edit'
         */
        title: {
            type: String,
            default: 'Add Text Field',
        },
        buttonText: {
            type: String,
            default: 'Create',
        },
        type: {
            type: String,
        },
        icon: {
            type: String,
        },
        route: {
            type: String,
            required: true,
        },
        currentField: {
            type: Object,
        },
        index: {
            type: Number,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */

    data() {
        return {
            fieldData: this.initializeFormData(),
            form: {
                radioOptions: [
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                ],
            },
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        list(value) {
            if (value) {
                this.listing = value
            }
        },
        //hide Popup after success response
        hidePopup(value) {
            if (value) {
                this.hideModal()
            }
        },
        currentField(value) {
            if (value) {
                this.fieldData = JSON.parse(JSON.stringify(value))
            }
        },
        index(value) {
            this.updatedIndex = value
        },
    },
    methods: {
        hideModal() {
            this.$emit('hide-modal')
            this.$validator.reset()
            this.$refs.modal.hide()
            Object.assign(this.fieldData, this.initializeFormData())
        },
        initializeFormData() {
            return {
                association: null,
                isRequired: false,
                isLocked: false,
                dataSegmentId: '',
                section: '',
                sectionTitle: '',
                type: 'text_field',
                sequenceNumber: 0,
                title: '',
                label: '',
                placeholder: '',
                options: [],
                icon: 'icon-text-field',
                maxLength: null,
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            let self = this
            const result = await this.$validator.validateAll()

            this.fieldData.dataSegmentId = this.dataSegmentId
            this.fieldData.title = this.fieldData.label
            this.fieldData.section = this.route
            this.fieldData.type = this.type
            this.fieldData.icon = this.icon
            this.fieldData.maxLength = this.type == 'text-area' ? 300 : 50
            this.fieldData.sectionTitle =
                this.route == 'setup_profile' ? 'Setup Profile' : 'Account Info'

            let passing = true

            if (result) {
                if (this.$parent.formData) {
                    if (
                        this.buttonText == 'Update' &&
                        this.$parent.formData[this.index].label.toLowerCase() ==
                            self.fieldData.label.toLowerCase()
                    ) {
                        passing = true
                    } else {
                        this.$parent.formData.forEach(function (list) {
                            if (
                                list.label.toLowerCase() ==
                                self.fieldData.label.toLowerCase()
                            ) {
                                passing = false
                            }
                        })
                    }
                }
                if (passing) {
                    this.$store.commit('setLoading', true)
                    if (this.buttonText === 'Update') {
                        Object.assign(
                            this.$parent.formData[this.index],
                            this.fieldData
                        )
                        this.$store.commit(
                            'setSuccess',
                            'Field has been updated. Please click on Update Form to save the changes.'
                        )
                    } else {
                        this.$parent.formData.push(
                            JSON.parse(JSON.stringify(self.fieldData))
                        )
                        this.$store.commit(
                            'setSuccess',
                            'Field has been added. Please click on Update to save the changes.'
                        )
                    }

                    setTimeout(function () {
                        self.$store.commit('setChangeDetect', true)
                        self.$store.commit('setLoading', false)
                        self.$refs.modal.hide()
                        self.clearFormData()
                    }, 2000)
                } else {
                    this.$store.commit('setError', 'Field already exists.')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.fieldData, this.initializeFormData())
        }, // End of clearFormData() method
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'dataSegmentId']),
    }, // End of Component > computed
}
</script>
